import {createI18n} from "vue-i18n";
import deSystemLanguage from '@/locales/system/de.json';
import enSystemLanguage from '@/locales/system/en.json';
import deLanguage from '@/locales/de.json';
import enLanguage from '@/locales/en.json';
import deepmerge from "deepmerge";

const messages = {
    de: deepmerge(deSystemLanguage, deLanguage),
    en: deepmerge(enSystemLanguage, enLanguage),
};

const i18n = createI18n({
    locale: 'de',
    fallbackLocale: 'en',
    legacy: false,
    globalInjection: true,
    messages
});

const $t = i18n.global.t;

export { i18n, $t };
